// import {DateTime} from 'luxon';
const state = {
  ventasData: [
    {
      id: 1,
      index: 0,
      codigo: 'px6H0Ixax3',
      id_cliente: 2,
      nombreCliente: "Leo DaVinci",
      id_usuario: 1,
      nombreVendedor: "Usuario Demo",
      servicios: [{"id":1,"id_categoria":1,"codigo":10001,"unidad":"kilo","minimo":4,"descripcion":"Ropa de vestir","precio":"16.50","total":"66.00","cantidad":4}],
      productos: [],
      total: 66,
      saldo: 0,
      denominacion: 0,
      metodo_pago: 'Pendiente',
      status_er: 'recibida',
      status_pago: 'pendiente',
      fecha_recepcion: '2022-02-01 16:22:06',
      humanFechaRecepcion: 'Mar 1, Febrero 2022 4:22pm',
      fecha_entrega: '2022-02-03 17:00',
      humanFechaEntrega: 'Jue 3, Feb 2022 5pm',
      fecha: '2022-02-01 16:22:06',
      humanFechaActualizacion: 'Mar 1, Febrero 2022 4:22pm',
    },
    {
      id: 2,
      index: 1,
      codigo: 'YX7YQ6TI47',
      id_cliente: 1,
      nombreCliente: "Cliente Demo",
      id_usuario: 1,
      nombreVendedor: "Usuario Demo",
      servicios: [{"id":1,"id_categoria":1,"codigo":10001,"unidad":"kilo","minimo":4,"descripcion":"Ropa de vestir","precio":"18.00","total":139.68,"cantidad":7.76}],
      productos: [],
      total: 139.68,
      saldo: 139.68,
      denominacion: 0,
      metodo_pago: 'Pendiente',
      status_er: 'recibida',
      status_pago: 'pendiente',
      fecha_recepcion: '2022-02-03 17:00',
      humanFechaRecepcion: 'Jue 3, Feb 2022 5pm',
      fecha_entrega: '2022-02-05 12:00',
      humanFechaEntrega: 'Sab 5, Feb 2022 12pm',
      fecha: '2022-02-03 17:00',
      humanFechaActualizacion: 'Jue 3, Feb 2022 5pm',
    },
  ],
};

const getters = {
  demoVentas: state => state.ventasData,
  demoVentasTotal: state => state.ventasData
    .map( venta => venta.total )
    .reduce((acumulator, currentVal)=> acumulator + currentVal ),
  lastInsertedDemoSalesFolio: state => {
    const lastIDX = state.ventasData.length -1;
    return state.ventasData[lastIDX].id;
  },
  demoVentasTotalByDateRange: (state) => (startingDate, endDate) => {
    return state.ventasData
    .map( venta => {
      const {fecha_recepcion} = venta;
      const start = new Date(startingDate);
      const end = new Date(endDate);
      const testDate = new Date(fecha_recepcion);
      return (testDate > start && testDate < end) ? venta:0.0;
    })
    .map( venta => venta.total )
    .reduce((acumulator, currentVal) => {
      const sum = acumulator + currentVal;
      return isNaN(sum)  ? 0 : sum;
    } );
  },
  getDemoSaleByCodigo: ( state ) => ( codigo ) => {
    return state.ventasData.find(venta=>venta.codigo === codigo);
  },
};

const actions = {
  saveNewDemoSale: ({commit}, payload)=>{
    commit('addNewSale', payload);
  },
};

const mutations = {
  addNewSale: (state, saleData) =>{ state.ventasData.push(saleData); }
};

export default{
  state,
  getters,
  actions,
  mutations
}